import { atom } from "jotai";

export const currentStepAtom = atom(1);
